export enum Errors {
  USER_ALREADY_EXIST = 'message:user-already-exist',
  USER_NOT_FOUND = 'message:user-not-found',
  SOMETHING_WENT_WRONG = 'message:something-went-wrong',
  MAXPHIV_NOT_AVAILABLE = 'message:maxphiv-not-available',
}
